import React from 'react';
import { useRoughCanvas } from '@/hooks/useRoughCanvas';

interface RoughBorderProps {
  color?: string;
  strokeWidth?: number;
  roughness?: number;
  seed?: number;
  className?: string;
}

const RoughBorder: React.FC<RoughBorderProps> = ({
  color = '#6b7a95',
  strokeWidth = 1.5,
  roughness = 0.8,
  seed = 1,
  className = '',
}) => {
  const canvasRef = useRoughCanvas(
    (rc, w, h) => {
      rc.rectangle(2, 2, w - 4, h - 4, { stroke: color, strokeWidth, roughness, seed });
    },
    [color, strokeWidth, roughness, seed],
  );

  return (
    <canvas
      ref={canvasRef}
      className={`rough-border-canvas ${className}`}
      aria-hidden="true"
    />
  );
};

export default RoughBorder;
